interface TextField {
  handleChange: (value: string) => void
  handleBlur: () => void
}

/**
 * Puts generated text into a form field and re-runs its leave-field check: a failed publish
 * stores its errors there, and inserted text never blurs the field on its own.
 */
export function applyGeneratedText(field: TextField, value: string): void {
  field.handleChange(value)
  field.handleBlur()
}
